import SearchBox from "../Component/SearchBox";
import {useEffect, useState} from "react";
import CampGrid from "../Layout/CampGrid";
import {Link, useParams} from "react-router-dom";
import {whitespaceMatcher} from "../Utilities/WhitespaceMatcher";
import {Badge, Box, Button, ButtonGroup, CardActions, CardContent, CardHeader, Divider, Grid2} from "@mui/material";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import {AccountBalance, Delete, Event, ManageAccounts} from "@mui/icons-material";

function LandingPage() {
    const params = useParams();
    const [query, setQuery] = useState(params?.query ?? '');
    const [items, setItems] = useState([]);
    const [filtered, setFiltered] = useState([]);

    useEffect(() => {
        setFiltered(items.filter((item) => whitespaceMatcher(query,
            [item.camp, item.organizer, item.organization, item.season].join(' '))
        ));
    }, [query, items]);

    useEffect(() => {
        const abortController = new AbortController();

        async function fetchData() {
            await fetch(`/api/organization`, {
                method: 'GET',
                signal: abortController.signal,
            }).then(res => res.json())
                .then(data => {
                    setItems(data);
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchData();
        return () => abortController.abort();
    }, []);
    const communities = [
        {id: 'Marki', icon: 'g_marki.svg'},
        {id: 'Odolanów', icon: 'g_odolanow.svg'},
        {id: 'Siechnice', icon: 'g_siechnice.svg'},
        {id: 'Swarzędz', icon: 'g_swarzedz.svg'},
    ]


    const cards = communities.map((item) => <Grid2 item size={{xs: 6, sm: 4, md: 2}} key={item.id}>
        <Card onClick={() => setQuery(item.id)} sx={{cursor: 'pointer'}}>
            <CardHeader subheader={item.id} />
            <CardContent sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-around'}}>
                <img src={'/communities/' + item.icon} style={{height: '100px'}} alt={item.id}/>
            </CardContent>
        </Card>
    </Grid2>);

    return (
        <main className={'App-main'}>
            {query === '' &&
                <Grid2 container spacing={4} justifyContent={'space-around'} flexWrap={'wrap'} sx={{width: '95vw', marginBottom: '10px'}}>
                    {cards}
                </Grid2>
            }
            <SearchBox label={'Wyszukaj po miejscu, organizatorze lub tytule'} query={query} setQuery={setQuery}/>
            <CampGrid items={filtered} />
        </main>
    );
}

export default LandingPage;